import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { LiftBoardParameterService } from './lift-board-parameter.service';
import { LiftBoardParameterCriteria } from '../models/lift-board-parameter.criteria';

@Injectable({ providedIn: 'root' })
export class LiftBoardGroupLookupResolver implements Resolve<any> {
  constructor(
    private parameterService: LiftBoardParameterService
  ) { }

  resolve(route: ActivatedRouteSnapshot) {
    let criteria = new LiftBoardParameterCriteria();
    criteria.liftBoardId = route.params.boardId;

    return this.parameterService.get(criteria.paramsExport());
  }
}
